import { useNavigate, useSearch } from '@tanstack/react-router';

import { Text } from '../../cdl/Text/Text';
import { OverviewCustomerCompanySelect } from '../../common/form-elements/CompanySelect/OverviewCustomerCompanySelect';
import { OverviewSupplierCompanySelect } from '../../common/form-elements/CompanySelect/OverviewSupplierCompanySelect';
import { translate } from '../../common/helpers/translate.helper';
import { useDocumentTitle } from '../../common/hooks/useDocumentTitle';
import { useRole } from '../../common/hooks/useRole';
import { Page } from '../../common/Page/Page';
import { PageGrid } from '../../common/PageGrid';
import { DebouncedSearchTextInput } from '../../common/Search/DebouncedSearchTextInput/DebouncedSearchTextInput';
import { Box } from '../../common/ui/Box';

import { AdminOfferOverviewTable } from './AdminOfferOverviewTable';
import { OfferOverviewSortSelect } from './OfferOverviewSortSelect';

export const AdminOfferOverviewPage = () => {
    const title = translate('offer.overviewPageTitle');
    useDocumentTitle(title);

    const role = useRole();

    const search = useSearch({ from: '/_app/offers' });
    const navigate = useNavigate({ from: '/offers' });

    return (
        <Page>
            <PageGrid>
                <Text variant="headline" as="h1">
                    {title}
                </Text>

                <Box display="flex" justifyContent="space-between" columnGap={8}>
                    <Box display="flex" columnGap={8}>
                        <Box minWidth="250px">
                            <DebouncedSearchTextInput
                                placeholder={translate('offer.searchInputPlaceholder')}
                                value={search.searchQuery ?? ''}
                                onChange={(searchQuery) => {
                                    navigate({
                                        search: (previousSearch) => ({
                                            ...previousSearch,
                                            searchQuery,
                                            page: 0,
                                        }),
                                    });
                                }}
                            />
                        </Box>

                        <OverviewCustomerCompanySelect
                            value={search.customerIds ?? []}
                            onChange={(customerIds) => {
                                navigate({
                                    search: (previousSearch) => ({
                                        ...previousSearch,
                                        customerIds,
                                        page: 0,
                                    }),
                                });
                            }}
                        />

                        {!role.isOneCompanyUser() || role.isSuperAdmin() ? (
                            <OverviewSupplierCompanySelect
                                value={search.supplierIds ?? []}
                                onChange={(supplierIds) => {
                                    navigate({
                                        search: (previousSearch) => ({
                                            ...previousSearch,
                                            supplierIds,
                                            page: 0,
                                        }),
                                    });
                                }}
                            />
                        ) : null}
                    </Box>

                    <Box minWidth="250px">
                        <OfferOverviewSortSelect
                            onChange={(sortValue) => {
                                navigate({
                                    search: (previousSearch) => ({
                                        ...previousSearch,
                                        sortValue,
                                        page: 0,
                                    }),
                                });
                            }}
                            value={search.sortValue}
                        />
                    </Box>
                </Box>

                <AdminOfferOverviewTable />
            </PageGrid>
        </Page>
    );
};
